import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import KundliMakingDetails from "../Kundli/KundliMakingDetails";
import { getKundliMakingData } from "../../redux/action/HoroscopeApi";
import { useDispatch,useSelector } from "react-redux";
// import axios from 'axios';

function KundliMatch() {

    const {  kundliMatchDetails, loading } = useSelector( state => state.horoscope  );
    const dispatch = useDispatch();

    console.log(loading)
    const [showResult, setShowResult] = useState(false);
    const [postData, setPostData] = useState(null);

//     const [citySuggestions, setCitySuggestions] = useState([]);
//  const [girlSuggestions, setGirlSuggestions] = useState([]);
// const [boySuggestions, setBoySuggestions] = useState([]);
const [girlCitySuggestions, setGirlCitySuggestions] = useState([]);
const [boyCitySuggestions, setBoyCitySuggestions] = useState([]);

  const [girl, setGirl] = useState({
    name: "",
    gender: "",
    dob: "",
    lat:"",
    lon:"",
    hour: "",
    minute: "",
    birthPlace: "",
  });

  const [boy, setBoy] = useState({
    name: "",
    gender: "",
    dob: "",
    lat:"",
    lon:"",
    hour: "",
    minute: "",
    birthPlace: "",
  });

  const handleChange = (e, person, setPerson) => {
    const { name, value } = e.target;
    setPerson((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validatePerson = (person, label = "Person") => {
    if (!person.name || person.name.length < 3) {
      toast.error(`${label}: Name must be at least 3 characters`);
      return false;
    }

    const requiredFields = ["gender", "dob", "hour", "minute", "birthPlace"];
    for (let field of requiredFields) {
      if (!person[field]) {
        toast.error(`${label}: ${field} is required`);
        return false;
      }
    }

    const hour = parseInt(person.hour, 10);
    const minute = parseInt(person.minute, 10);

    if (isNaN(hour) || hour < 1 || hour > 12) {
        toast.error(`${label}: Hour must be between 1 and 12`);
        return false;
    }

    if (isNaN(minute) || minute < 0 || minute > 60) {
        toast.error(`${label}: Minute must be between 0 and 60`);
        return false;
    }


    return true;
  };

  const handleSubmit = () => {
    const isGirlValid = validatePerson(girl, "Girl");
    const isBoyValid = validatePerson(boy, "Boy");

    if (isGirlValid && isBoyValid) {
        const girlDobFormatted = moment(girl.dob).format("DD/MM/YYYY");
        const girlBirthTime = `${String(girl.hour).padStart(2, '0')}:${String(girl.minute).padStart(2, '0')}`;

        const boyDobFormatted = moment(boy.dob).format("DD/MM/YYYY");
        const boyBirthTime = `${String(boy.hour).padStart(2, '0')}:${String(boy.minute).padStart(2, '0')}`;

        const postdata = {
            api_key:'2885bcc2-c254-5fec-ad3b-7c19248d189e', //Your API key
            boy_dob : boyDobFormatted , ///Date of Birth - 
            boy_tob : boyBirthTime , //Birth time Time of Birth in Hours - HH:MM
            boy_tz  : '5.5', //TimeZone
            boy_lat : boy.lat,//latno, //Latitude
            boy_lon : boy.lon, //lngno, //Longitude
            boy_birthplace:boy.birthPlace, //api not required
            boy_name: boy.name,
            boy_gender: boy.gender,
          
            girl_name: girl.name,
            girl_gender:girl.gender,
            girl_dob: girlDobFormatted  , ///Date of Birth - 
            girl_tob: girlBirthTime, //Birth time Time of Birth in Hours - HH:MM
            girl_tz : '5.5', //TimeZone
            girl_lat: girl.lat,//latno, //Latitude
            girl_lon: girl.lon, //lngno, //Longitude
            girl_birthplace:girl.birthPlace, //api not required
            lang:'en', //language
        };

        // console.log(postdata)
        dispatch(getKundliMakingData(postdata));

        setPostData(postdata); // ✅ Store it
        setShowResult(true);

        toast.success("Submitted successfully");
    } else {
      setShowResult(false);
    }
  };


  ////

   const fetchCitySuggestions = async (query, setSuggestions) => {
        if (!query) {
            setSuggestions([]);
            return;
        }

        try {
            const res = await fetch(`https://manageonline.in/demo/mibhagya/WEB_V21/HomeApi/searchCities?query=${query}`);
            const data = await res.json();
            setSuggestions(data);
        } catch (error) {
            console.error("Failed to fetch city suggestions:", error);
        }
    };

 console.log(postData);
  return (
    <>
      <section className="horoscope_top kundali_report">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 text-center">
              <img alt="ring" src="./assets/images/export-ring.svg" />
              <h1>
                KUNDLI <span>Making</span>
              </h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                tempus purus a varius consequat. Mauris ligula ex, auctor vel
                tortor at, vulputate porta justo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {showResult === true?
            <KundliMakingDetails 
            kundliMatchDetails={kundliMatchDetails} 
            postData={postData} 
            />
       :
        <>
      <section className="kundalirpdetail">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="details-container">
                <div className="first_name">
                  <p className="first_name_paragraph">Fill Details</p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Girl Section */}
            <div className="col-lg-6 col-md-6 col-12">
              <div className="chart_bar leftch">
                <div className="chart_heading">
                  <h2>
                    <span className="girl_icon-det">
                      <img src="./assets/images/girl-detail.svg" alt="Girl" />
                    </span>
                    Girl
                  </h2>
                </div>
                <div className="kundlidate">
                  <div className="row mb-3">
                    <div className="col">
                      <label className="form-label">Name*</label>
                      <input
                        type="text"
                        name="name"
                        value={girl.name}
                        onChange={(e) => handleChange(e, girl, setGirl)}
                        className="form-control"
                        placeholder="Enter Your Name"
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">Gender*</label>
                      <select
                        name="gender"
                        value={girl.gender}
                        onChange={(e) => handleChange(e, girl, setGirl)}
                        className="form-select"
                      >
                        <option value="">Enter Your Gender</option>
                        <option value="female">Female</option>
                        <option value="male">Male</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Date Of Birth*</label>
                    <input
                      type="date"
                      name="dob"
                      className="form-control"
                      onChange={(e) => handleChange(e, girl, setGirl)}
                      value={girl.dob}
                      max={new Date().toISOString().split("T")[0]}
                    />
                  </div>

                  <div className="mb-3 time_birth">
                    <label className="form-label">Birth Time*</label>
                    <div className="row">
                      <div className="col">
                        <input
                          type="number"
                            min={1} 
                            max={12} 
                          name="hour"
                          value={girl.hour}
                          onChange={(e) => handleChange(e, girl, setGirl)}
                          className="form-control"
                          placeholder="Hours"
                        />
                      </div>
                      <div className="col">
                        <input
                          type="number" 
                            min={0} 
                            max={60} 
                          name="minute"
                          value={girl.minute}
                          onChange={(e) => handleChange(e, girl, setGirl)}
                          className="form-control"
                          placeholder="Minutes"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Birth Place*</label>
                    <input
                        type="text"
                        name="birthPlace"
                        value={girl.birthPlace}
                        onChange={(e) => {
                            handleChange(e, girl, setGirl);
                            fetchCitySuggestions(e.target.value, setGirlCitySuggestions);
                        }}

                        className="form-control"
                        placeholder="Place"
                        />
                        {girlCitySuggestions.length > 0 && (
                        <ul className="absolute w-full bg-white shadow-lg border border-gray-300 rounded-md mt-1 max-h-60 overflow-y-auto z-10 suggestion-list">
                            {girlCitySuggestions.map((city, index) => (
                            <li
                                className="px-4 py-2 hover:bg-indigo-100 cursor-pointer"
                                key={index}
                                onClick={() => {
                                setGirl((prev) => ({
                                    ...prev,
                                    birthPlace: city.city + ', ' + city.country,
                                    lat: city.lat,
                                    lon: city.lng,
                                }));
                                setGirlCitySuggestions([]);
                                }}
                            >
                                <div className="font-medium">{city.city}, {city.country}</div>
                            </li>
                            ))}
                        </ul>
                        )}


                  </div>
                </div>
              </div>
            </div>

            {/* Boy Section */}
            <div className="col-lg-6 col-md-6 col-12">
              <div className="chart_bar rightch">
                <div className="chart_heading">
                  <h2>
                    <span className="boy_icon-det">
                      <img src="./assets/images/boy-detail.svg" alt="Boy" />
                    </span>
                    Boy
                  </h2>
                </div>
                <div className="kundlidate">
                  <div className="row mb-3">
                    <div className="col">
                      <label className="form-label">Name*</label>
                      <input
                        type="text"
                        name="name"
                        value={boy.name}
                        onChange={(e) => handleChange(e, boy, setBoy)}
                        className="form-control"
                        placeholder="Enter Your Name"
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">Gender*</label>
                      <select
                        name="gender"
                        value={boy.gender}
                        onChange={(e) => handleChange(e, boy, setBoy)}
                        className="form-select"
                      >
                        <option value="">Enter Your Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Date Of Birth*</label>
                    <input
                      type="date"
                      name="dob"
                      className="form-control"
                      onChange={(e) => handleChange(e, boy, setBoy)}
                      value={boy.dob}
                      max={new Date().toISOString().split("T")[0]}
                    />
                  </div>

                  <div className="mb-3 time_birth">
                    <label className="form-label">Birth Time*</label>
                    <div className="row">
                      <div className="col">
                        <input
                           type="number"
                           maxLength={2}
                            min={1} 
                            max={12} 
                          name="hour"
                          value={boy.hour}
                          onChange={(e) => handleChange(e, boy, setBoy)}
                          className="form-control"
                          placeholder="Hours"
                        />
                      </div>
                      <div className="col">
                        <input
                          type="number" 
                            min={0} 
                            max={60} 
                            maxLength={2}
                          name="minute"
                          value={boy.minute}
                          onChange={(e) => handleChange(e, boy, setBoy)}
                          className="form-control"
                          placeholder="Minutes"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Birth Place*</label>
                    <input
                        type="text"
                        name="birthPlace"
                        value={boy.birthPlace}
                        onChange={(e) => {
                            handleChange(e, boy, setBoy);
                            fetchCitySuggestions(e.target.value, setBoyCitySuggestions);
                        }}
                        className="form-control"
                        placeholder="Place"
                        />
                        {boyCitySuggestions.length > 0 && (
                        <ul className="absolute w-full bg-white shadow-lg border border-gray-300 rounded-md mt-1 max-h-60 overflow-y-auto z-10 suggestion-list">

                            
                            {boyCitySuggestions.map((city, index) => (
                            <li  
                                className="px-4 py-2 hover:bg-indigo-100 cursor-pointer"
                                key={index}
                                onClick={() => {
                                setBoy((prev) => ({
                                    ...prev,
                                    birthPlace: city.city,
                                    lat: city.lat,
                                    lon: city.lng,
                                }));
                                setBoyCitySuggestions([]);
                                }}
                                 
                                >
                                <div className="font-medium"> {city.city}, {city.country}</div>
                            </li>
                            ))}
                        </ul>
                        )}

                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="row">
            <div className="second_section__kundli_button-bar">
              <button className="btn btn-primary" onClick={handleSubmit}>
                Matching Result
              </button>
            </div>
          </div>
        </div>
      </section>
        </> 
        }


      <section className="our_astrologers">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center astro as_padderTop50">
              <div className="astroo1">
                <p>
                  {"For detail horoscope analysis, speak to our astrologers"}
                  <br />
                  <NavLink to="/expert">Click Here</NavLink>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default KundliMatch;
